<template>
  <div>
    <review-list-item
      :hide-change-links="hideChangeLinks || !question.isVoterEligible"
      icon="thumbs_up_down"
      :route="route"
    >
      <span slot="label">{{ removalLabel }}</span>
      <span slot="content" v-if="question.isVoterEligible">
        {{ removalAnswer }}
      </span>
      <span slot="content" v-else>
        Voting on this question is limited to {{ subgroupsFormatted }}.
      </span>
    </review-list-item>
  </div>
</template>

<script>
import ReviewListItem from './ReviewListItem.vue';

import {subgroups} from '@/vuex/helpers.js';

export default {
  components: {
    ReviewListItem
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    questionId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    hideChangeLinks: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    removalLabel() {
      return this.question.name
        ? `${this.question.name}`
        : 'Directors to Remove';
    },
    route() {
      return `/questions/${this.questionId}`;
    },
    removalAnswer() {
      const votes = this.question.vote.selection;
      const electionArray = votes.filter(v => !!v);
      if (electionArray.length === 0) {
        return 'I choose not to remove any directors';
      }
      return electionArray.join(', ');
    },
    subgroupsFormatted() {
      return subgroups(this.question).toUpperCase();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Review/ReviewQuestionRemovalItem.vue